import MoveToMailboxContext from '../store/schema/MoveToMailboxContext';
import { action } from 'satcheljs';

// Reset all the values of store to initial default values
export const resetMovetoStore = action('RESET_MOVETO_STORE');

/**
 * Action executed when user changes the text of moveTo mailbox menu search box
 * @param searchText - the searched text
 */
export const onSearchTextChanged = action(
    'ON_MOVETO_SEARCH_TEXT_CHANGES',
    (searchText: string) => ({ searchText })
);

/**
 * When user clicks to see all folders of any mailbox (primary or archive) then this action is dispatched
 * @param moveToMailboxContext - the moveTo mailbox context for which all folders should be shown(consequently search and new folders also falls in this context)
 * @param rootFolderId - Root folder id of the folder clicked
 */
export const onViewAllMenuClicked = action(
    'ON_VIEW_ALL_MENU_CLICKED',
    (moveToMailboxContext: MoveToMailboxContext, rootFolderId?: string) => ({
        moveToMailboxContext,
        rootFolderId,
    })
);

/**
 * When moveto context has to be changed
 * @param moveToMailboxContext - the moveTo mailbox context for which all folders should be shown(consequently search and new folders also falls in this context)
 */
export const onChangeMoveToContext = action(
    'ON_CHANGE_MOVE_TO_CONTEXT',
    (moveToMailboxContext: MoveToMailboxContext) => ({ moveToMailboxContext })
);

/**
 * When new folder item's text is changed then this action is called
 * @param folderText - the text by which new folder can be created
 */
export const onNewFolderTextChanged = action(
    'SET_NEW_FOLDER_TEXT',
    (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, folderText: string) => ({
        folderText: folderText,
    })
);

// set the new folder item's text as invalid
export const onNewFolderTextInvalidated = action('SET_NEW_FOLDER_INVALID_STATE');

/**
 * when focus or blur happens for search box in moveTo mailbox menu
 * @param isFocusInSearchBox - a boolean to say if seach box is focused or not focused(blurred)
 */
export const setIsFocusInSearchBox = action(
    'SET_FOCUS_IN_SEARCH_BOX',
    (isFocusInSearchBox: boolean) => ({ isFocusInSearchBox })
);

// Clicking on new folder menu item will dispatch this action
export const onNewFolderMenuClicked = action('NEW_FOLDER_MENU_CLICK');

// This action is called to reset the new folder menu item state
export const resetNewFolderViewState = action('RESET_NEW_FOLDER_VIEWSTATE');
